import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tenant } from '../models/tenant';

@Injectable({
  providedIn: 'root',
})
export class BaseTenantService {
  protected http = inject(HttpClient);


  protected BASE_URL = environment.RH_BASE_URL;

  protected MGMT_BASE_URL = `${environment.RH_BASE_URL}/mgmt/tenants`;

  public getById(tenantId: string): Observable<Tenant.Tenant> {
    return this.http.get<Tenant.Tenant>(`${this.MGMT_BASE_URL}/${tenantId}`);
  }

  public update(
    tenantId: string,
    tenant: Partial<Tenant.Tenant>
  ): Observable<HttpResponse<any>> {
    return this.http.patch<HttpResponse<any>>(
      `${this.MGMT_BASE_URL}/${tenantId}`,
      tenant,
      {
        observe: 'response',
        responseType: 'json',
      }
    );
  }
}
